	import stringUtils from "../assets/js/stringUtil.js";
export function tableOperation(val,type,controlInfo,that) {
				var i = 0;
				var j = 0;
				var reg = /[\u4e00-\u9fa5]/g;
				var names = val.match(reg).join("");
				var controls = that.templateData.TemplateContent.Controls;
				var delInd = 0;
				var copyArr = JSON.parse(JSON.stringify(controls));
				if (type == "delete") {
					for (i = 0; i < controls.length; i++) {
						if (copyArr[i].Id== controlInfo.Id) {
							// controls.splice(i, 1);
							copyArr.splice(i, 1);
							delInd = i;
							break;
						}
					}
					controls = JSON.parse(JSON.stringify(copyArr));
					this.$set(that.templateData.TemplateContent,"Controls",controls)
					var count = 0;
					var control = null;
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text.indexOf(names) >= 0) {
							control = controls[i];
							count++;
						}
					}
					if (count == 1) {
						that.$set(control, 'deleteIsShow', false);
					} else {
						that.$set(controlInfo, 'deleteIsShow', true);
					}
				} else if(type == "delAndVal"){
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Id== controlInfo.Id) {
							controls.splice(i, 1);
							break;
						}
					}
					var count = 0;
					var control = null;
					for (i = 0; i < controls.length; i++) {
						let colText = controls[i].Property.Title[0].Text;
						var reg = /[\u4e00-\u9fa5]/g;
						var cname = colText.match(reg).join("");
						var cval = val.match(reg).join("");
						if (cname.indexOf(cval) >= 0) {
							control = controls[i];
							count++;
						}
					}
					if (count == 1) {
						that.$set(control, 'deleteIsShow', false);
					} else {
						that.$set(controlInfo, 'deleteIsShow', true);
					}
				} else if(type == "addAndVal"){
					that.$set(controlInfo, 'deleteIsShow', true);
					controlInfo.Id="Table-"+guid();
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == val) {
							var control = JSON.stringify(controls[i]);
							control = JSON.parse(control);
							control.Id="Table-"+guid();
							var children = control.Config.Table.Children;
							for (var y = 0; y < children.length; y++) {
								if((children[y].Property.Title[0].Text != "角色层级") && (children[y].Property.Title[0].Text != "部门分佣比例") && (children[y].Property.Title[0].Text != "角色计佣比例")){
									children[y].Value = "";
								}
								if (children[y].Property.Title[0].Text === "员工工号"){
									this.$set(children[y],"value",null);
								}
							}
							controls.splice(i + 1, 0, control);
							break;
						}
					}
				} else {
					that.$set(controlInfo, 'deleteIsShow', true);
					controlInfo.Id="Table-"+guid();
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text == val) {
							var control = JSON.stringify(controls[i]);
							control = JSON.parse(control);
							control.Id="Table-"+guid();
							var children = control.Config.Table.Children;
							for (var y = 0; y < children.length; y++) {
								children[y].Value = null;
								if (children[y].value !== undefined){
									children[y].value = null;
								}
								if (children[y].ValuesSelectClear !== undefined && children[y].ValuesSelectClear === true){
									this.$set(children[y],'ValuesSelect',null);
								}
								children[y].Values = null;
							}
							controls.splice(i + 1, 0, control);
							break;
						}
					}
				}
				if(type == "addAndVal"||type == "delAndVal"){
					for (i = 0; i < controls.length; i++) {
						var reg = /[\u4e00-\u9fa5]/g;
						var cname = val.match(reg).join("");
						var cval = controls[i].Property.Title[0].Text.match(reg).join("");
						let inx = val.indexOf("息");
						let newVal = val.slice(0,inx + 1);
						if (cval.indexOf(cname) >= 0) {
							if (j == 0) {
								controls[i].Property.Title[0].Text = newVal;
							} else {
								controls[i].Property.Title[0].Text = newVal + j;
							}
							j++;
						}
					}
				}else{
					for (i = 0; i < controls.length; i++) {
						if (controls[i].Property.Title[0].Text.indexOf(names) >= 0) {
							if (j == 0) {
								
								controls[i].Property.Title[0].Text = names;
							} else {
								controls[i].Property.Title[0].Text = names + j;
							}
							j++;
						}
					}
				}
}
function S4() {
    return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
}
function findDelSum (controls,delInx,names){
	let count = 0;
	for (let i = delInx; i < controls.length; i++) {
		if (controls[i].Property.Title[0].Text.indexOf(names) >= 0) {
			count++;
		}
	}
	return count;
}
export function guid() {
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}